import * as enums from '@/common/helpers/enums'

export default enums.fromValues({
    '売買･賃貸の別': 'type',
    '募集･成約の別': 'done',
    '成約時期': 'dealtAt',
    '募集時期': 'openedAt',
    '金額': 'dealPrice',
    '専有面積': 'sqm',
    '延床面積': 'totalFloorSqm',
    'バルコニー面積': 'balconySqm',
    '土地面積': 'landSqm',
    '間取り': 'floorPlan',
    '所在階': 'floor',
    '号室･区画': 'roomNumber',
    '物件名': 'building.name',
    '所在地': 'building.address',
    '階建': 'building.floorsCount',
    '築年月': 'building.builtAt',
    '物件種別': 'building.type',
    '構造': 'building.structure',
    '総戸数': 'building.unitsCount',
    'データID': 'id'
})
